import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const recipient = {
    get: {
        // @Url /v1/recipients/{cbidx}
        recipients: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/{idx}
        beforeRegInfo: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/essential-file/{idx}
        essentialFile: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/essential-file/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/receiver-overlap-check
        receiverOverlapCheck: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/receiver-overlap-check`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/register/{idx}
        advanceRegister: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/register/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/detail-info/{idx}
        recipientDetail: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/detail-info/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/memo/{idx}
        memo: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/memo/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/personal-charge-history/{idx}
        personalChargeHistory: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/personal-charge-history/${params.idx}`, {
                    params
                }
            )
        },
        // @Url /v1/rfid/{cbidx}
        rfid: async(params) => {
            return await http.get(
                `${URLs.rfid}/${params.cbidx}`, {
                    params
                }
            )
        },
        // @Url /v1/rfid/{cbidx}/log-ym
        rfidLogYm: async(params) => {
            return await http.get(
                `${URLs.rfid}/${params.cbidx}/log-ym`, {
                    params
                }
            )
        },
        // @Url /v1/personal-list/{cbidx}
        personal: async(params) => {
            return await http.get(
                `${URLs.personalList}/${params.cbidx}`, {
                    params
                }
            )
        },
        // @Url /v1/personal-list-log/{cbidx}
        personalListLog: async(params) => {
            return await http.get(
                `${URLs.personalList}-log/${params.cbidx}`, {
                    params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary/{idx}
        salary: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/salary/${params.idx}`, {
                    params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary-caregiver-list
        salaryCaregiverList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/salary-caregiver-list`, {
                    params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract
        contract: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/contract`, {
                    params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/renewal
        renewal: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/renewal`, {
                    params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}
        ltcarebEval: async(params) => {
            return await http.get(
                `${URLs.ltcareb}/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/details/{idx}
        ltcarebEvalDetails: async(params) => {
            return await http.get(
                `${URLs.ltcareb}/${params.cbidx}/details/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/receiver-type
        simpleList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/receiver-type`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/receiver-offer-schedule
        receiverOfferSchedule: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/receiver-offer-schedule`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/standard-use-plan
        standardUsePlan: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/standard-use-plan`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/standard-use-change-plan
        standardUseChange: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/standard-use-change-plan`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/diary-list
        diaryList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/diary-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/class-bcd-details/{idx}
        bcdDetails: async(params) => {
            return await http.get(
                `${URLs.ltcareb}/${params.cbidx}/class-bcd-details/${params.idx}`, {
                    params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/class-a-mdetails/{idx}
        classAMdetailsCheck: async(params) => {
            return await http.get(
                `${URLs.ltcareb}/${params.cbidx}/class-a-mdetails/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/standard-use-change-plan/{idx}
        standardUseChangePlan: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/standard-use-change-plan/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-detail-info/{idx}
        serviceProvidePlan: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/offer-plan-detail-info/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-need-area
        serviceProvidePlanNeedArea: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/offer-plan-need-area`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-need-area-subcode
        serviceProvidePlanNeedContent: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/offer-plan-need-area-subcode`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/recipient-contract-list
        recipientContractList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/recipient-contract-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/service-log-nurse-list
        serviceLogNurseList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/service-log-nurse-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/service-log-nurse
        serviceLogNurse: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/service-log-nurse`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-list
        stateReportList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/state-report-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/counsel-list
        counselList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/counsel-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/counsel
        counsel: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/counsel`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/item-usage-log-list
        itemUsageLogList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/item-usage-log-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/item-usage-log
        itemUsageLog: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/item-usage-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/medicine-purchase
        medicinePurchase: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/medicine-purchase`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/medicine-log-list
        medicineLogList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/medicine-log-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/medicine-log
        medicineLogDetail: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/medicine-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/synthesis-report-list
        synthesisReportList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/synthesis-report-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/zipcode
        zipcode: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/zipcode`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/ipso-print
        ipsoPrint: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/ipso-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/change-salary-notice
        changeSalaryNotice: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/change-salary-notice`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-schedule
        offerSchedule: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/offer-schedule`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/renew-contract/{idx}
        renewContract: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/renew-contract/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-change/{idx} 
        contractChange: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/contract-change/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/reipients/{cbidx}/renewal-contract/{idx}
        renewalContract: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/renewal-contract/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/deposit-list
        depositList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/deposit-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/submit-file-list
        submitFileList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/submit-file-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/essential-file-list
        essentialFileList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/essential-file-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/personal/{cbidx}/charge-deposit/{idx}
        chargeDeposit: async(params) => {
            return await http.get(
                `${URLs.personal}/${params.cbidx}/charge-deposit/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/personal/{cbidx}/charge-deposit
        chargeDepositAll: async(params) => {
            return await http.get(
                `${URLs.personal}/${params.cbidx}/charge-deposit`, {
                    params: params
                }
            )
        },
        // @Url /v1/personal/{cbidx}/deposit-confirm/{idx}
        depositConfirm: async(params) => {
            return await http.get(
                `${URLs.personal}/${params.cbidx}/deposit-confirm/${params.idx}`, {
                    params: params
                }
            )
        },
         // @Url /v1/personal/{cbidx}/deposit-confirm
        depositConfirmAll: async(params) => {
            return await http.get(
                `${URLs.personal}/${params.cbidx}/deposit-confirm`, {
                    params: params
                },
            )
        },
        // @Url /v1/personal/{cbidx}/pay-ledger
        payLedger: async(params) => {
            return await http.get(
                `${URLs.personal}/${params.cbidx}/pay-ledger`, {
                    params: params
                }
            )
        },
        // @Url /v1/personal/{cbidx}/pay-info
        payInfo: async(params) => {
            return await http.get(
                `${URLs.personal}/${params.cbidx}/pay-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/mailing-ledger
        mailingLedger: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/mailing-ledger`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/service-offer-ledger
        serviceOfferLedger: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/service-offer-ledger`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/service-offer-ledger/print
        serviceLedgerPrint: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/service-offer-ledger/print`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/work-progress
        workProgress: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/work-progress`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/use-amount
        useAmount: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/use-amount`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/addition-amount
        additionAmount: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/addition-amount`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/dash
        dash: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/dash`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/dash-suade-contract
        dashSuadeContract: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/dash-suade-contract`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/dash-rfid-tag-use
        dashRfidTagUse: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/dash-rfid-tag-use`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/adjust-report-schedule
        adjustReportSchedule: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/adjust-report-schedule`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/change-type-confirm
        changeTypeConfirm: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/change-type-confirm`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/qualify-check-request
        qualifyCheckRequest: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/qualify-check-request`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/personal-reduce-apply
        personalReduceApply: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/personal-reduce-apply`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/month-schedule-list
        monthSchedule: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/month-schedule-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/personal/non-payment
        nonPayment: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/personal/non-payment`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-once 새로운 수급계약 조회 API
        contractOnce: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/contract-once`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-renew-once 새로운 갱신계약 조회 API
        contractRenewOnce: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/contract-renew-once`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-renewal-once 새로운 재계약 조회 API
        contractRenewalOnce: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/contract-renewal-once`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/bank-account
        bankAccount: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/bank-account`, {
                    params: params
                }
            )
        },
        // @Url /v1/rfid/{cbidx}/error-log
        errorLog: async(params) => {
            return await http.get(
                `${URLs.rfid}/${params.cbidx}/error-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/rfid/{cbidx}/plan-compare
        planCompare: async(params) => {
            return await http.get(
                `${URLs.rfid}/${params.cbidx}/plan-compare`, {
                    params: params
                }
            )
        },
        // @Url /v1/rfid/{cbidx}/plan-compare-day
        planCompareDay: async(params) => {
            return await http.get(
                `${URLs.rfid}/${params.cbidx}/plan-compare-day`, {
                    params: params
                }
            )
        },
        // @Url /v1/senior/{cbidx}/sms-info
        smsInfo: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/sms-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/new-personal-push
        newPersonalPush: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/new-personal-push`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/pre-sms-info
        preSmsInfo: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/pre-sms-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/deposit-list-all
        depositListAll: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/deposit-list-all`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/service-log-nurse-print
        serviceLogNursePrint: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/service-log-nurse-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-print-select
        stateReportPrintSelect: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/state-report-print-select`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/counsel-print
        counselPrint: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/counsel-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/excel/{cbidx}/error-log
        ServiceErrorLog: async(params) => {
            return await http.get(
                `/v1/sync/excel/${params.cbidx}/error-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/schedule-management
        scheduleManagement: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/schedule-management`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/schedule-sbidx-butidx
        scheduleSbidxButidx: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/schedule-sbidx-butidx`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/excel/{cbidx}/error-log
        ServiceErrorLog: async(params) => {
            return await http.get(
                `/v1/sync/excel/${params.cbidx}/error-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/schedule-management/salary
        scheduleManagementSalary: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/schedule-management/salary`, {
                    params: params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/class-a-mdetails-before/{idx}
        classAMdetailsBefore: async(params) => {
            return await http.get(
                `/v1/ltcareb-eval/${params.cbidx}/class-a-mdetails-before/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/class-bcd-details-before/{idx}
        classBcdDetailsBefore: async(params) => {
            return await http.get(
                `/v1/ltcareb-eval/${params.cbidx}/class-bcd-details-before/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/5/state-report-print
        stateReportPrint: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/state-report-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/simple
        recipientSmple: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/simple`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/suade-contract-list 
        suadeContractList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/suade-contract-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-payment
        cmsPayment: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/cms-payment`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-member/{idx}
        cmsMember: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/cms-member/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-paying-count/{idx}
        cmsPayingCount: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/cms-paying-count/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-payment-api/{idx}
        cmsPaymentApi: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/cms-payment-api/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/hometax-medical-expense-deduct
        medicalExpense: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/hometax-medical-expense-deduct`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/number-codes-year
        numberCodesYear: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/number-codes-year`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary-offer-plan-change
        offerPlanChange: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/salary-offer-plan-change`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary-offer-plan-change/related-docs
        relatedDoc: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/salary-offer-plan-change/related-docs`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary-offer-plan-change-print
        planChangePrint: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/salary-offer-plan-change-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/emergency-electap-list
        emergencyList: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/emergency-electap-list`, {
                    params: params
                }
            )
        }
    },
    post: {
        // @Url /v1/recipients/{cbidx}/before-reg/{idx}
        beforeReg: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/before-reg/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx
                    },
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/ess-files-upload/{idx}
        essFilesUpload: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/ess-files-upload/${params.idx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/register/{idx}
        advanceRegister: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/register/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/memo/{idx}
        memo: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/memo/${params.idx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/memo/{idx}/{midx}
        updateMemo: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/memo/${params.idx}/${params.midx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/detail-info/{idx}
        detail: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/detail-info/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx,
                        suadeContractIdx: params.suadeContractIdx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/socialworker/{idx}
        socialworker: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/socialworker/${params.idx}`, formData,
            )
        },
        // @Url /v1/recipients/{cbidx}/charge-staff/{idx} 
        chargeStaff: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/charge-staff/${params.idx}`, formData,
            )
        },
        // @Url /v1/recipients/{cbidx}/charge-state/{idx}
        chargeState: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/charge-state/${params.idx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/personal-charge-change/{idx}
        changePersonalCharge: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/personal-charge-change/${params.idx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/pay-info/{idx}
        payInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/pay-info/${params.idx}`, formData,
            )
        },
        // @Url /v1/recipients/{cbidx}/salary/{idx}
        salary: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/salary/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        salaryUsePlanIdx: params.data.salaryUsePlanIdx
                    },
                }
            )
        },
        // @Url v1/recipients/{cbidx}/register-confirm/{idx}
        registerConfirm: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/register-confirm/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx,
                    },
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/charge-staff-all
        chargeStaffAll: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/charge-staff-all`,
                formData,
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/class-bcd-details/{idx}
        classBCDdetails: async(params) => {
            return await http.post(
                `${URLs.ltcareb}/${params.cbidx}/class-bcd-details/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx
                    },
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/file/{idx}
        evalImage: async(params) => {
            let formData = objectToFormdata(params)
            params.files.forEach((item, i) => {
                formData.append(`fileNameList[${i}]`, item.name)
                formData.append(`fileEncList[${i}]`, item.encByte)
                formData.append(`file[${i}]`, item.file)
            })
            return await http.post(
                `${URLs.ltcareb}/${params.cbidx}/file/${params.idx}`, formData
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/class-a-mdetails/{idx}
        classAMdetails: async(params) => {
            return await http.post(
                `${URLs.ltcareb}/${params.cbidx}/class-a-mdetails/${params.idx}`,
                params.baseEvalVO, {
                    params: {
                        luidx: params.luidx,
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/standard-use-change-plan/{idx}
        standardUseChangePlan: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/standard-use-change-plan/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-detail-info/{idx}
        offerPlanDetailInfo: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/offer-plan-detail-info/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        syncYn: params.syncYn,
                        ltcareBasisEvaluationIdx: params.ltcareBasisEvaluationIdx,
                        ltcareSalaryOfferPlanIdx: params.ltcareSalaryOfferPlanIdx,
                    },
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/item-usage-log
        itemUsageLog: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/item-usage-log`,
                params
            )
        },
        // @Url /v1/recipients/{cbidx}/counsel
        counsel: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/counsel`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/service-log-nurse
        serviceLogNurse: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/service-log-nurse`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }

            )
        },
        // @Url /v1/recipients/{cbidx}/medicine-log
        medicineLog: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/medicine-log`,
                params, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                        homeReceiverIdx: params.homeReceiverIdx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/synthesis-report
        synthesisReport: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/synthesis-report`,
                params.synthesisReport, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-file
        stateReportFile: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report-file`, formData
            )
        },
        // @Url /v1/personal/{cbidx}/deposit
        deposit: async(params) => {
            return await http.post(
                `${URLs.personal}/${params.cbidx}/deposit`,
                params, {
                    params: params
                }
            )
        },
        // @Url /v1/personal/{cbidx}/deposit-list
        depositList: async(params) => {
            return await http.post(
                `${URLs.personal}/${params.cbidx}/deposit-list`,
                params, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                        yyyymm: params.yyyymm,
                        soloYn: params.soloYn,
                        personalYn: params.personalYn
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/renew-contract/{idx}
        renewContract: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/renew-contract/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx,
                    },
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/renewal-contract/{idx}
        renewalContract: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/renewal-contract/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/personal-push
        personalPush: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/personal-push`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/personal-push-select
        personalPushSelect: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/personal-push-select`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/customers/{cbidx}/mailing-ledger
        mailingLedger: async(params) => {
            return await http.post(
                `${URLs.customer}/${params.cbidx}/mailing-ledger`,
                params.mailManageLedgerVO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        },
        // @Url /v1/customers/{cbidx}/mailing-ledger-file
        mailingLedgerFile: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.customer}/${params.cbidx}/mailing-ledger-file`, formData
            )
        },
        // @Url /v1/customers/{cbidx}/service-offer-ledger
        serviceOfferSign: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/service-offer-ledger`, formData
            )
        },
        // @Url /v1/management/{cbidx}/adjust-report-schedule
        adjustReportSchedule: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.management}/${params.cbidx}/adjust-report-schedule`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/charge-state
        chargeStateAll: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/charge-state`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-push/{idx}
        offerPlanPush: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/offer-plan-push/${params.idx}`, formData
            )
        },
        // @Url v1/calendars/{cbidx}/sync-receiver-offer-schedule
        syncOfferSchedule: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.calendars}/${params.cbidx}/sync-receiver-offer-schedule`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/personal/non-payment
        nonPayment: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/personal/non-payment`, formData
            )
        },

        // @Url /v1/recipients/{cbidx}/contract-once
        contractOnce: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/contract-once`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-renew-once
        contractRenewOnce: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/contract-renew-once`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-once-add/{idx}
        contractOnceAdd: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/contract-once-add/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx
                    },
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-file/{idx}
        offerPlanFile: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/offer-plan-file/${params.idx}`, formData
            )
        },
        // @Url /v1/senior/{cbidx}/sms-info
        smsInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.senior}/${params.cbidx}/sms-info`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/new-personal-push
        newPersonalPush: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/new-personal-push`,
                params, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/approval-amount
        approvalAmount: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/approval-amount`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/schedule-management
        scheduleManagement: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/schedule-management`,
                params.offerList, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                        homeReceiverIdx: params.homeReceiverIdx,
                        homeSeniorIdx: params.homeSeniorIdx,
                        selYm: params.selYm,
                        doType: params.doType
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/sync-recipient-ministry 
        syncMinistry: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/sync-recipient-ministry`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/charge-state-change
        chargeStateChange: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/charge-state-change`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-member/{idx}
        cmsMember: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/cms-member/${params.homeReceiverIdx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-payment-req
        cmsPaymentReq: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/cms-payment-req`,
                params, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                        selYm: params.selYm
                    }
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-payment-rereq
        cmsPaymentReReq: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/cms-payment-rereq`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-payment-deposit
        cmsPaymentDeposit: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/cms-payment-deposit`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/salary-offer-plan-change
        offerPlanChange: async(params) => {
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/salary-offer-plan-change`, 
                params, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        }
    },
    delete: {
        // @Url /v1/recipients/{cbidx}/charge-staff/{idx}
        chargeStaff: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/charge-staff/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/receiver-overlap-check
        receiverOverlapCheck: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/receiver-overlap-check`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/memo/{idx}/{midx}
        memo: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/memo/${params.idx}/${params.midx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary/{idx}
        salary: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/salary/${params.suadeContractIdx}`, {
                    params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/charge-staff/{idx} 
        chargeStaff: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/charge-staff/${params.idx}`, {
                    params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/ltcareb-eval-detail
        ltcarebEvalDetail: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/ltcareb-eval-detail`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/ltcareb-eval
        ltcarebEval: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/ltcareb-eval`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/standard-use-change-plan/{idx}
        standardUseChangePlan: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/standard-use-change-plan/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/counsel
        counsel: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/counsel`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/item-usage-log
        itemUsageLog: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/item-usage-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/service-log-nurse
        serviceLogNurse: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/service-log-nurse`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/medicine-log
        medicineLog: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/medicine-log`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipinets/{cbidx}/synthesis-report
        synthesisReport: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/synthesis-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/personal/{cbidx}/deposit
        deposit: async(params) => {
            return await http.delete(
                `${URLs.personal}/${params.cbidx}/deposit`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/essential-file
        essentialFileType: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/essential-file`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/mailing-ledger-log/{idx}
        mailingLedgerLog: async(params) => {
            return await http.delete(
                `${URLs.customer}/${params.cbidx}/mailing-ledger-log/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/adjust-report-schedule
        adjustReportSchedule: async(params) => {
            return await http.delete(
                `${URLs.management}/${params.cbidx}/adjust-report-schedule`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/personal/non-payment
        nonPayment: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/personal/non-payment`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-change/{idx}
        contractChange: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/contract-change/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/service-offer-ledger
        serviceOfferLedger: async(params) => {
            return await http.delete(
                `${URLs.customer}/${params.cbidx}/service-offer-ledger`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/offer-plan-file/{idx}
        offerPlanFile: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/offer-plan-file/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/personal-charge-history/{idx}
        personalChargeHistory: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/personal-charge-history`, {
                    params: params
                }
            )
        },
        // @Url /v1/ltcareb-eval/{cbidx}/salary-offer-plan
        salaryOfferPlan: async(params) => {
            return await http.delete(
                `${URLs.ltcareb}/${params.cbidx}/salary-offer-plan`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/contract-changes
        contractChanges: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/contract-changes`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-payment
        cmsPayment: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/cms-payment`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/cms-member/{idx}
        cmsMember: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/cms-member/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/salary-offer-plan-change/{idx}
        offerPlanChange: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/salary-offer-plan-change/${params.idx}`, {
                    params:params
                }
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/recipients.js